import React, { Component } from 'react';
import Loader from '../../../../components/Loader/index';
import { connect } from 'react-redux';
import RouteInfo from '../../../../components/RouteInfo';
import AbnormalityInfo from '../components/generic/AbnormalityInfo';
import AssigneeInfo from '../../../../components/AssigneeInfo';
import { Button, Row } from 'react-bootstrap';
import map from 'lodash/map';
import ManifestGroupInfo from './ManifestGroupInfo';
import UnrelatedManifestsModal from '../components/UnrelatedManifestsModal';
import {
    clearJourneyBuilderAnalysisData,
    getAbnormalityAnalysis,
    getIsFetching,
    loadAbnormalityAnalysis,
    silentFetchAbnormalityAnalysis,
} from '../../analysisDuck';
import { createAbnormalityAnalysisBreadcrumb } from '../../../../shared/utils/breadcrumbs';
import { isManifestBased } from '../../../../shared/utils/abnormalityHelpers';

class GenericAbnormalityAnalysis extends Component {
    state = { openUnrelatedManifestsModal: false };

    componentDidMount() {
        this.props.clearJourneyBuilderAnalysisData();
        this.props.loadAbnormalityAnalysis(this.props.params.abnormalityId);
    }

    render() {
        const { openUnrelatedManifestsModal } = this.state;
        const { abnormalityAnalysisPending, abnormalityAnalysis } = this.props;

        if (abnormalityAnalysisPending) {
            return <Loader />;
        }

        return (
            <div>
                {abnormalityAnalysis &&
                    createAbnormalityAnalysisBreadcrumb(
                        abnormalityAnalysis,
                        isManifestBased(abnormalityAnalysis.genericAbnormalityType)
                    )}
                <Row>
                    <RouteInfo
                        colSize={6}
                        routeCode={abnormalityAnalysis && abnormalityAnalysis.routeCode}
                        runDate={abnormalityAnalysis && abnormalityAnalysis.runDate}
                        runSeq={abnormalityAnalysis && abnormalityAnalysis.runSequence}
                    />
                    <AssigneeInfo
                        colSize={6}
                        assignee={abnormalityAnalysis && abnormalityAnalysis.assignee}
                        assigneeGroup={
                            abnormalityAnalysis && abnormalityAnalysis.groupRoleAssignees
                        }
                    />
                </Row>
                <Row>
                    <AbnormalityInfo
                        abnormalityType={abnormalityAnalysis && abnormalityAnalysis.abnormalityType}
                        abnormalityStatus={
                            abnormalityAnalysis && abnormalityAnalysis.abnormalityStatus
                        }
                        abnormalityDate={abnormalityAnalysis && abnormalityAnalysis.abnormalityDate}
                        abnormalityLocation={abnormalityAnalysis && abnormalityAnalysis.stop}
                        trailerIdentifier={
                            abnormalityAnalysis && abnormalityAnalysis.trailerIdentifier
                        }
                    />
                </Row>
                {abnormalityAnalysis &&
                    abnormalityAnalysis.manifestGroups &&
                    abnormalityAnalysis.manifestGroups.length > 0 &&
                    map(abnormalityAnalysis.manifestGroups, mfg => (
                        <ManifestGroupInfo
                            key={`${mfg.name}_${Math.random()}`}
                            manifestGroup={mfg}
                            abnormalityId={abnormalityAnalysis.abnormalityId}
                        />
                    ))}
                <Button
                    bsStyle="primary"
                    style={{ margin: 10 }}
                    onClick={() => this.setState({ openUnrelatedManifestsModal: true })}
                >
                    Plan recovery action with other manifests
                </Button>
                {openUnrelatedManifestsModal && (
                    <UnrelatedManifestsModal
                        showModal={openUnrelatedManifestsModal}
                        abnormalityId={this.props.params.abnormalityId}
                        onClose={() =>
                            this.setState({
                                openUnrelatedManifestsModal: false,
                            })
                        }
                        onHide={() =>
                            this.setState({
                                openUnrelatedManifestsModal: false,
                            })
                        }
                    />
                )}
            </div>
        );
    }
}

export default connect(
    (state, props) => ({
        abnormalityAnalysis: getAbnormalityAnalysis(state, props.params.abnormalityId),
        abnormalityAnalysisPending: getIsFetching(state),
    }),
    {
        clearJourneyBuilderAnalysisData,
        loadAbnormalityAnalysis,
        silentFetchAbnormalityAnalysis,
    }
)(GenericAbnormalityAnalysis);
